export default __webpack_public_path__ + "static/kyndryl-06b9b9b36509d59dec34d62cdbb153d2.png";